import React from 'react';
import { NormalButton } from '@croquiscom-pvt/zds';

import { PDPCustomAttributeKeys } from '@common/test-automation';

import { KakaoPurchaseButton } from './KakaoPurchaseButton';

interface ConfirmButtonsProps {
  buttonTypes: {
    from?: 'recommendations' | 'cart' | 'ordersheet' | 'similar_products' | 'tf_invite_challenge';
    isSample?: boolean;
    isEditable?: boolean;
    isStoreDeal?: boolean;
    isProductPreview?: boolean;
    showBuyNowOnly?: boolean;
    showPurchaseWithKakao?: boolean;
    showAddToCartInPreview?: boolean;
  };
  actions: {
    purchase: () => void;
    purchaseKaKao: () => void;
    addToCart: (add_to_cart_now?: boolean) => void;
    onEditClick?: () => void;
  };
  editState: {
    isEditDisabled?: boolean;
  };
}

export const ConfirmButtons: React.FC<React.PropsWithChildren<ConfirmButtonsProps>> = ({
  buttonTypes: {
    from,
    isSample,
    isEditable,
    isStoreDeal,
    isProductPreview,
    showBuyNowOnly,
    showPurchaseWithKakao,
    showAddToCartInPreview,
  },
  actions: { purchase, purchaseKaKao, addToCart, onEditClick },
  editState: { isEditDisabled },
}) => {
  if (isEditable) {
    return (
      <NormalButton
        fullWidth
        className='btn'
        variant='primary'
        size='large'
        disabled={isEditDisabled}
        onClick={onEditClick}
      >
        변경하기
      </NormalButton>
    );
  }

  // 샘플 상품일 경우(현재는 한국 대상 뷰티관에서만 사용)
  if (isSample) {
    return (
      <NormalButton fullWidth className='btn' variant='tertiary' size='large' onClick={purchase}>
        샘플 신청하기
      </NormalButton>
    );
  }

  // 상품 미리보기 (주문팀에서 사용 ex.장바구니)
  if (isProductPreview) {
    const hasPurchaseButton = from === 'recommendations';

    return (
      <>
        {(!hasPurchaseButton || showAddToCartInPreview) && (
          <NormalButton fullWidth className='btn' variant='tertiary' size='large' onClick={() => addToCart()}>
            장바구니
          </NormalButton>
        )}
        {hasPurchaseButton && (
          <NormalButton fullWidth className='btn' variant='tertiary' size='large' onClick={() => addToCart(true)}>
            함께 구매
          </NormalButton>
        )}
      </>
    );
  }

  if (showPurchaseWithKakao) {
    return (
      <>
        <NormalButton
          fullWidth
          className='btn'
          variant='secondaryGray'
          size='large'
          data-custom-ta-key={PDPCustomAttributeKeys.PDP_CART_11}
          onClick={() => addToCart()}
        >
          장바구니
        </NormalButton>
        <NormalButton
          fullWidth
          className='btn'
          variant='primary'
          size='large'
          data-custom-ta-key={PDPCustomAttributeKeys.PDP_DIRECT_PURCHASE_10}
          onClick={purchase}
        >
          바로구매
        </NormalButton>
        <KakaoPurchaseButton onClick={purchaseKaKao} />
      </>
    );
  }

  if (showBuyNowOnly) {
    return (
      <NormalButton
        fullWidth
        className='btn'
        variant='primary'
        size='large'
        onClick={purchase}
        data-custom-ta-key={PDPCustomAttributeKeys.PDP_DIRECT_PURCHASE_10}
      >
        바로구매
      </NormalButton>
    );
  }

  if (isStoreDeal) {
    return (
      <NormalButton
        fullWidth
        className='btn'
        variant='primary'
        size='large'
        data-custom-ta-key={PDPCustomAttributeKeys.PDP_DIRECT_PURCHASE_10}
        onClick={() => addToCart()}
      >
        장바구니
      </NormalButton>
    );
  }

  return (
    <>
      <NormalButton
        fullWidth
        className='btn'
        variant='secondaryGray'
        size='large'
        data-custom-ta-key={PDPCustomAttributeKeys.PDP_CART_11}
        onClick={() => addToCart()}
      >
        장바구니
      </NormalButton>
      <NormalButton
        fullWidth
        className='btn'
        variant='primary'
        size='large'
        data-custom-ta-key={PDPCustomAttributeKeys.PDP_DIRECT_PURCHASE_10}
        onClick={purchase}
      >
        바로구매
      </NormalButton>
    </>
  );
};
